export function parseAgentOrigin(url: string): string | undefined {
    try {
        return new URL(url).origin;
    } catch (e) {
        console.error("[AgentChat] Invalid agent URL:", url, e);
        return undefined;
    }
}

/** Chat agent display name: "PathFinder" under the PathFinder Agentic UI lab, otherwise "PathFinder AI". */
export function getAgentDisplayName(isAgenticUI: boolean): string {
    return isAgenticUI ? "PathFinder" : "PathFinder AI";
}

/** Width the Quick agent chat panel takes (and publishes as --qa-panel-width) while collapsed. */
export const AGENT_CHAT_PANEL_COLLAPSED_WIDTH_PX = 48;
